import { jsPDF } from "jspdf";

// Structured record-review PDF: header, field sheet, associated activity, footer with doc ID
export const downloadProfilePdf = ({ title, subtitle, fields = [], activities = [] }) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const margin = 48;
  let y = 64;

  const line = (text, size = 10, bold = false, color = [55, 65, 81]) => {
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.setFontSize(size);
    doc.setTextColor(...color);
    const wrapped = doc.splitTextToSize(String(text ?? "—"), 500);
    if (y + wrapped.length * (size + 4) > 790) {
      doc.addPage();
      y = 64;
    }
    doc.text(wrapped, margin, y);
    y += wrapped.length * (size + 4) + 2;
  };

  line("NestTrack — Record Review", 16, true, [226, 160, 188]);
  line(title, 14, true);
  if (subtitle) line(subtitle, 10, false, [107, 114, 128]);
  y += 8;
  doc.setDrawColor(252, 230, 233);
  doc.line(margin, y, 548, y);
  y += 16;

  fields.forEach(([k, v]) => {
    line(`${k}:`, 9, true, [156, 163, 175]);
    line(Array.isArray(v) ? v.join(", ") : v || "—", 10);
    y += 4;
  });

  if (activities.length) {
    y += 10;
    line("Associated Activity", 12, true);
    y += 4;
    activities.forEach((a) =>
      line(`[${a.ts ? new Date(a.ts).toLocaleString() : ""}] ${a.action} — ${a.details}${a.user_email ? ` (${a.user_email})` : ""}`, 9, false, [107, 114, 128])
    );
  }

  y += 16;
  line(`Generated ${new Date().toLocaleString()} · Doc ID ${Date.now().toString(36).toUpperCase()}`, 8, false, [156, 163, 175]);
  doc.save(`${title.replace(/\W+/g, "-").toLowerCase()}-record.pdf`);
};
